import { render, staticRenderFns } from "./EventsListItem.vue?vue&type=template&id=5abf973d&scoped=true&"
import script from "./EventsListItem.vue?vue&type=script&lang=js&"
export * from "./EventsListItem.vue?vue&type=script&lang=js&"
import style0 from "./EventsListItem.vue?vue&type=style&index=0&id=5abf973d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abf973d",
  null
  
)

export default component.exports